
import {
    useConfirm,
} from "melco-shared-logic";
import { Drawer as DrawerType } from "../../hooks/drawer/useGenericDrawer";
import { useEffect } from "react";
import { useExtendTrial } from "../../hooks/users/useExtendTrial";

export interface ExtendTrialActionButtonInterface {
    "product_code": string,
    //    "subscription_code": string,
    "extendTrialDateTime"?: Date,
    "userIdToExtendTrial": string;
    "product_version_number": string;
}

type ExtendTrialActionButtonProps = {
    ExtendTrialActionDetails: ExtendTrialActionButtonInterface;
    referencesDrawer?: DrawerType;
    openAskConirmationBoxTrigger: boolean;
    onCloseDrawer: (closeDrawer: boolean) => void;
};

export const ExtendTrialActionButton: React.FC<
    ExtendTrialActionButtonProps
> = ({ openAskConirmationBoxTrigger, ExtendTrialActionDetails, onCloseDrawer }) => {
    const ExtendTrial = useExtendTrial(ExtendTrialActionDetails.userIdToExtendTrial);

    const confirmExtendTrial = useConfirm(
        async () => {
            await ExtendTrial(ExtendTrialActionDetails);
            onCloseDrawer(false);
        },
        {
            translationPrefix: "users.tabs.trials.actions.extendtrial",
        }
    );

    useEffect(() => {
        confirmExtendTrial();
    }, [openAskConirmationBoxTrigger])

    return (
        <></>
    );
};
